import styled from 'styled-components';

const Card = styled.div`
  border: 1px solid #e6e6e6;
  border-radius: 10px;
  padding: 32px;
  background: white;
`;
const ButtonWrap = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  @media screen and (max-width: 600px) {
    flex-direction: column;
    button {
      margin-bottom: 16px;
    }
  }
`;

export default { Card, ButtonWrap };
